import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  IconButton,
  styled,
  useTheme,
  Grid2
} from "@mui/material";
import { MdCheckCircle } from "react-icons/md";
import PaginationComponent from "components/ui-components/PaginationComponent";


const StyledTableHead = styled(TableCell)({
  fontWeight: 500,
  fontSize: "14px",
  color: "#505258",
  padding: "10px 14px",
  backgroundColor: "#F8F8F8",
  border: "none",
  textAlign: "center",
  whiteSpace: "nowrap",
  letterSpacing: "-0.2px",
});

const StyledTableRow = styled(TableCell)(({ theme }) => ({
  fontWeight: 400,
  fontSize: "14px",
  color: "#5052588A",
  padding: "10px 14px",
  backgroundColor: "#FFFFFF",
  borderBottom: "1px solid #D8D8D8",
  textAlign: "center",
  whiteSpace: "nowrap",
  letterSpacing: "-0.2px",
}));

// Dummy data array
const data = [
  {
    id: "001",
    material: "Steel",
    boqQty: 4000,
    boqRate: 6000,
    boqAmount: 24000000,
    actualQty: 4000,
    actualRate: 6200,
    actualAmount: 248000000,
    varQty: 0,
    varRate: 2000,
    varAmount: 8000000,
    claimable: true,
    overrun: 8000000,
  },
  {
    id: "002",
    material: "Cement",
    boqQty: 2000,
    boqRate: 500,
    boqAmount: 1000000,
    actualQty: 2200,
    actualRate: 520,
    actualAmount: 1144000,
    varQty: 200,
    varRate: 20,
    varAmount: 144000,
    claimable: false,
    overrun: 144000,
  },
  {
    id: "001",
    material: "Steel",
    boqQty: 4000,
    boqRate: 6000,
    boqAmount: 24000000,
    actualQty: 4000,
    actualRate: 6200,
    actualAmount: 248000000,
    varQty: 0,
    varRate: 2000,
    varAmount: 8000000,
    claimable: true,
    overrun: 8000000,
  },
  {
    id: "002",
    material: "Cement",
    boqQty: 2000,
    boqRate: 500,
    boqAmount: 1000000,
    actualQty: 2200,
    actualRate: 520,
    actualAmount: 1144000,
    varQty: 200,
    varRate: 20,
    varAmount: 144000,
    claimable: false,
    overrun: 144000,
  },
  {
    id: "001",
    material: "Steel",
    boqQty: 4000,
    boqRate: 6000,
    boqAmount: 24000000,
    actualQty: 4000,
    actualRate: 6200,
    actualAmount: 248000000,
    varQty: 0,
    varRate: 2000,
    varAmount: 8000000,
    claimable: true,
    overrun: 8000000,
  },
  {
    id: "002",
    material: "Cement",
    boqQty: 2000,
    boqRate: 500,
    boqAmount: 1000000,
    actualQty: 2200,
    actualRate: 520,
    actualAmount: 1144000,
    varQty: 200,
    varRate: 20,
    varAmount: 144000,
    claimable: false,
    overrun: 144000,
  },
];

const MaterialReceiptList = () => {
  const theme = useTheme();
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 4;

  const totalPages = Math.ceil(data.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentRows = data.slice(startIndex, endIndex);

  return (
    <Box
      sx={{
        padding: 0,
        background: "#fff",
        borderRadius: 2,
        height: "100%",
        border: "1px solid #2525252E",
      }}
    >
      <Grid2 container>
        <Grid2 xs={12} md={6} sx={{ p: 2 }}>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "18px",
              lineHeight: "100%",
              letterSpacing: "-0.4px",
              color: `${theme?.customSettings?.themeColor || "#000"}`,
            }}
          >
            Material Variance List
          </Typography>
          <Typography
            sx={{
              mt: "5px",
              color: "#5052588A",
              fontSize: "14px",
              mb: "22px",
              lineHeight: "100%",
              letterSpacing: "-0.4px",
            }}
          ></Typography>
        </Grid2>
      </Grid2>

      <Paper sx={{ boxShadow: "none" }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableHead rowSpan={2} sx={{ border: "1px solid #E9E9E7", borderLeft: 0 }}>
                  SL No
                </StyledTableHead>
                <StyledTableHead rowSpan={2} sx={{ border: "1px solid #E9E9E7" }}>
                  Material
                </StyledTableHead>
                <StyledTableHead colSpan={3} sx={{ borderTop: "1px solid #E9E9E7", borderRight: "1px solid #E9E9E7", pt: 3 }}>
                  As per Original BOQ Budget
                </StyledTableHead>
                <StyledTableHead colSpan={3} sx={{ borderTop: "1px solid #E9E9E7", borderRight: "1px solid #E9E9E7", pt: 3 }}>
                  As per Actuals
                </StyledTableHead>
                <StyledTableHead colSpan={3} sx={{ borderTop: "1px solid #E9E9E7", borderRight: "1px solid #E9E9E7", pt: 3 }}>
                  Variations
                </StyledTableHead>
                <StyledTableHead rowSpan={2} sx={{ borderTop: "1px solid #E9E9E7", borderBottom: "1px solid #E9E9E7", borderRight: "1px solid #E9E9E7" }}>
                  Claimable from Client
                </StyledTableHead>
                <StyledTableHead rowSpan={2} sx={{ borderTop: "1px solid #E9E9E7", borderBottom: "1px solid #E9E9E7" }}>
                  Cost Overrun
                </StyledTableHead>
              </TableRow>

              <TableRow>
                {["Qty", "Rate", "Amount", "Qty", "Rate", "Amount", "Qty", "Rate", "Amount"].map((item, index) => (
                  <StyledTableRow
                    key={index}
                    sx={{
                      borderBottom: "1px solid #E9E9E7",
                      backgroundColor: "#F8F8F8",
                      fontWeight: 400,
                      fontSize: "11",
                      color: "#505258",
                      borderRight: (index + 1) % 3 === 0 ? "1px solid #E9E9E7" : undefined,
                    }}
                  >
                    {item}
                  </StyledTableRow>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {currentRows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={13} align="center" sx={{ py: 4 }}>
                    <Typography color="textSecondary">No Data Available</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                currentRows.map((row, index) => (
                  <TableRow key={row.id}>
                    <StyledTableRow>{row.id}</StyledTableRow>
                    <StyledTableRow>{row.material}</StyledTableRow>
                    <StyledTableRow>{row.boqQty}</StyledTableRow>
                    <StyledTableRow>{row.boqRate}</StyledTableRow>
                    <StyledTableRow>{row.boqAmount}</StyledTableRow>
                    <StyledTableRow>{row.actualQty}</StyledTableRow>
                    <StyledTableRow>{row.actualRate}</StyledTableRow>
                    <StyledTableRow>{row.actualAmount}</StyledTableRow>
                    <StyledTableRow>{row.varQty}</StyledTableRow>
                    <StyledTableRow>{row.varRate}</StyledTableRow>
                    <StyledTableRow>{row.varAmount}</StyledTableRow>
                    <StyledTableRow>
                      {row.claimable ? (
                        <MdCheckCircle style={{ height: "20px", width: "20px", color: "#3E756D" }} />
                      ) : (
                        "-"
                      )}
                    </StyledTableRow>
                    <StyledTableRow>{row.overrun}</StyledTableRow>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <Box sx={{ display: "flex", justifyContent: "flex-end", backgroundColor: "#fff", p: 2 }}>
        <PaginationComponent
          pageNumber={currentPage}
          totalPages={totalPages || 1}
          onPageChange={setCurrentPage}
        />
      </Box>
    </Box>
  );
};

export default MaterialReceiptList;
